export class Item {
  $key: string;
  title: string;
  body: string;
  active = true;
  timeStamp: number;
}



// WEBPACK FOOTER //
// ./src/app/items/shared/item.ts